/**
 * Nguồn dữ liệu báo cáo
 */
export default {
    Audit: 1,  // sau kiểm tra
    Estimate: 2,  // sau lập
    Submit: 3, // lần nộp
  };
  